module.exports = __webpack_public_path__ + "img/icon-consumer-payments.cd4c0743.svg";